import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { PhysicianFilter } from 'src/app/model/physician-Filter';
import { CacheFilterService } from 'src/app/services/cache/cache-filter.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { PatientAssignationService } from 'src/app/services/patient-assignation.service';

@Component({
  selector: 'app-patient-crm-coordinator-dialog',
  templateUrl: './patient-crm-coordinator-dialog.component.html',
  styleUrls: ['./patient-crm-coordinator-dialog.component.css']
})
export class PatientCrmCoordinatorDialogComponent implements OnInit {

  filterCompletePhysicianFilter: FilterCompleteService<PhysicianFilter>; ;
  form: FormGroup;

  constructor( private cacheFilterService: CacheFilterService,
               private notificationToastService: NotificationToastService,
               private patientAssignationService: PatientAssignationService,
               private formBuilder: FormBuilder,
               public dialogRef: MatDialogRef<PatientCrmCoordinatorDialogComponent>,
               @Inject(MAT_DIALOG_DATA) public data: number) {

    this.form = this.formBuilder.group({
      physician: ['', Validators.required]
    });

    this.filterCompletePhysicianFilter =
      new FilterCompleteService<PhysicianFilter>([], this.form.controls.physician);

  }

  get f() { return this.form.controls; }

  get filterCompletePhysicianFilterOptions() { return this.filterCompletePhysicianFilter ?
    this.filterCompletePhysicianFilter.filteredOptions : []; }

  async ngOnInit() {

    const physicians = await this.cacheFilterService.getPhysicianFilters();

    this.filterCompletePhysicianFilter =
      new FilterCompleteService<PhysicianFilter>(physicians,
        this.form.controls.physician);
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  async save() {
    try {
      if (!this.form.invalid) {
        await this.patientAssignationService
          .assignCoordinator(
              this.data,
              this.form.controls.physician.value.Id);

        this.dialogRef.close(
           this.form.controls.physician.value
        );
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Asignación de profesional');
    }
  }

}
